import { IEntity } from '../interfaces/entity';
import { SubjectType } from './subject-type';
import { ProcessType } from './process-type';

export interface IEngineRuleList{
    items: EngineRule[];
    totalCount: number;
  }

// const data for demo
export const SUBJECTS = ['Address', 'Case', 'Person'];
export const RULES = ['Compare Fields', 'Record Added', 'Field Changed', 'Field set to value', 'Disable Field Until'];
export const PERSONFIELDS = ['Date of Birth', 'Forename', 'Home Telephone', 'Middlename', 'Mobile Telephone', 'Surname', 'Title'];
export const CASEFIELDS = ['Date Closed', 'Date Opened', 'Info Source', 'Category'];
export const ACTIONS = ['Email Case Owner', 'Email Case Manager', 'Set field value', 'Add a record'];
export const OPERATORS = ['Must Be', 'Must Not Be'];
export const COMPARATORS = ['Equal To', 'Greater Than', 'Less Than'];

export const DUMMYRULES: EngineRule[] = [
    {
        id: 1,
        uid: '1',
        RuleType: 'Compare Fields',
        RuleConditions: '',
        RuleSummary: 'Field Date Opened cannot be greater than field Date Closed',
    },
    {
        id: 2,
        uid: '2',
        RuleType: 'Record Added',
        RuleConditions: '',
        RuleSummary: 'When a record is added Email Case Manager',
    },
];

export class EngineRule implements IEntity
{
  // this will also need id, guid, subjectid and processid
  id: number;
  uid: string;
  RuleType: string;
  RuleConditions: string; // created classes for each rule type and store this as JSON
  RuleSummary: string; // this is user friendly version of the rule
//  subjectTypeId: number;
//  subjectType: SubjectType;
// processTypeId: number;
//  processType: ProcessType;

  constructor(engineRule?)
  {
    engineRule = engineRule || {};
    this.id = engineRule.id;
    this.uid = engineRule.uid;
    this.RuleType = engineRule.RuleType;
    this.RuleSummary = engineRule.RuleSummary;
    this.RuleConditions = engineRule.RuleConditions;
 //   this.subjectTypeId = engineRule.subjectTypeId;
 //   this.subjectType = engineRule.subjectType;
 //   this.processTypeId = engineRule.processTypeId;
  //  this.processType = engineRule.processTypeType;
  }

}
